import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { CalendarDays, Eye, ArrowLeft, MessageCircle } from "lucide-react";
import { news, company } from "../mock";
import { Reveal } from "../components/Shared";
import useSEO from "../hooks/useSEO";

const HaberDetay = () => {
  const { id } = useParams();
  const article = news.find((n) => n.id === id);

  useSEO({
    title: article ? article.title : "Haberler",
    description: article ? article.excerpt : undefined,
  });

  if (!article) return <Navigate to="/haberler" replace />;

  const others = news.filter((n) => n.id !== id).slice(0, 2);

  return (
    <div>
      {/* Hero */}
      <section className="relative bg-[#0d2b4f] pt-40 pb-20 overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="absolute inset-0 w-full h-full object-cover opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#081f3b]/95 via-[#0d2b4f]/85 to-[#0d2b4f]/70" />
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <Link
              to="/haberler"
              className="inline-flex items-center gap-2 text-white/70 hover:text-white text-sm font-medium transition-colors"
            >
              <ArrowLeft size={16} />
              Tüm Haberler
            </Link>
            <h1 className="mt-5 text-2xl sm:text-3xl lg:text-[34px] font-bold text-white leading-snug tracking-tight">
              {article.title}
            </h1>
            <div className="mt-5 flex items-center gap-5 text-sm text-white/60">
              <span className="flex items-center gap-1.5">
                <CalendarDays size={15} className="text-[#1e9cd7]" />
                {article.date}
              </span>
              <span className="flex items-center gap-1.5">
                <Eye size={15} className="text-[#1e9cd7]" />
                {article.views} Görüntülenme
              </span>
            </div>
          </Reveal>
        </div>
      </section>

      {/* Content */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Reveal>
            <img
              src={article.image}
              alt={article.title}
              className="w-full h-[300px] sm:h-[420px] object-cover rounded-2xl shadow-lg"
            />
            <div className="mt-10 space-y-6">
              {article.content.map((p, i) => (
                <p
                  key={i}
                  className="text-[#3a4a5d] leading-[1.9] text-[16px]"
                >
                  {p}
                </p>
              ))}
            </div>

            <div className="mt-12 bg-[#f5f8fb] border border-slate-100 rounded-2xl p-7 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-5">
              <div>
                <h3 className="font-bold text-[#0d2b4f] text-lg">
                  Hizmetlerimiz hakkında bilgi almak ister misiniz?
                </h3>
                <p className="mt-1 text-sm text-[#5b6b7d]">
                  {company.phone} numarasından ya da WhatsApp üzerinden bize
                  ulaşabilirsiniz.
                </p>
              </div>
              <a
                href={company.whatsappHref}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-whatsapp inline-flex items-center gap-2 px-6 py-3 rounded-full font-semibold text-sm shrink-0"
              >
                <MessageCircle size={17} />
                Teklif Al
              </a>
            </div>
          </Reveal>

          {/* Other news */}
          {others.length > 0 && (
            <Reveal>
              <div className="mt-16">
                <h2 className="text-xl font-bold text-[#0d2b4f] mb-7 tracking-tight">
                  Diğer Haberler
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                  {others.map((n) => (
                    <Link
                      key={n.id}
                      to={`/haberler/${n.id}`}
                      className="news-card group flex gap-4 bg-white border border-slate-100 rounded-2xl p-4"
                    >
                      <div className="w-24 h-24 rounded-xl overflow-hidden shrink-0">
                        <img
                          src={n.image}
                          alt={n.title}
                          className="w-full h-full object-cover"
                        />
                      </div>
                      <div>
                        <span className="text-xs text-[#5b6b7d] flex items-center gap-1.5">
                          <CalendarDays size={12} className="text-[#1e9cd7]" />
                          {n.date}
                        </span>
                        <h3 className="mt-1.5 text-sm font-bold text-[#0d2b4f] leading-snug group-hover:text-[#1e9cd7] transition-colors line-clamp-2">
                          {n.title}
                        </h3>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </Reveal>
          )}
        </div>
      </section>
    </div>
  );
};

export default HaberDetay;
